import React, { useState, useEffect } from 'react';
import Navbar from './components/sections/Navbar';
import HeroSection from './components/sections/HeroSection';
import AboutSubmenu from './components/sections/AboutSubmenu';
import AboutUs from './components/sections/AboutUs';
import MissionVision from './components/sections/MissionVision';
import TestimonialsCarousel from './components/sections/TestimonialsCarousel';
import CommunitySection from './components/sections/CommunitySection';
import ContactForm from './components/sections/ContactForm';
import FAQAccordion from './components/sections/FAQAccordion';
import Footer from './components/sections/Footer';
import ScrollToTop from './components/sections/ScrollToTop';
import ServicesSection from './components/sections/ServicesSection';
import ProcessSection from './components/sections/ProcessSection';  
import CareersSection from './components/sections/CareersSection';  

export default function Home() {
  const [activeSection, setActiveSection] = useState('about-us');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['about-us', 'mission', 'process', 'testimonials', 'community'];
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom >= 200) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      
      <div id="about">
        <AboutSubmenu activeSection={activeSection} />
        <AboutUs />
        <MissionVision />
        <ProcessSection />
        <TestimonialsCarousel />
        <CommunitySection />
      </div>

      <ServicesSection />
      <ContactForm />
      <FAQAccordion />
      <CareersSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
}